import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';

const ScheduledTours = ({ scheduledTours }) => {
  const navigate = useNavigate(); // Initialize useNavigate

  // These functions should ideally dispatch actions to update the Redux store
  const cancelTour = (tourId) => {
    console.log('Cancel tour:', tourId);
    // Dispatch action to cancel tour in Redux store
  };

  const rescheduleTour = (tourId) => {
    console.log('Reschedule tour:', tourId);
    // Dispatch action to reschedule tour in Redux store
  };

  if (scheduledTours?.length === 0) {
    return (
      <div className="bg-card rounded-lg border border-border p-6">
        <h2 className="text-lg font-semibold text-foreground mb-4">Scheduled Tours</h2>
        <div className="text-center py-8">
          <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="Calendar" size={24} className="text-muted-foreground" />
          </div>
          <p className="text-muted-foreground mb-4">No tours scheduled</p>
          <Button
            variant="outline"
            iconName="Calendar"
            iconPosition="left"
            onClick={() => navigate('/schedule-tour')} // Assuming a route for scheduling tours
          >
            Schedule a Tour
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground">Scheduled Tours</h2>
        <Button
          variant="ghost"
          size="sm"
          iconName="Calendar"
          iconPosition="left"
          onClick={() => navigate('/schedule-tour')} // Assuming a route for scheduling tours
        >
          Schedule New
        </Button>
      </div>
      <div className="space-y-4">
        {scheduledTours?.map((tour) => (
          <div key={tour?.id} className="border border-border rounded-lg p-4">
            <div className="flex items-start space-x-4">
              <div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0">
                <Image
                  src={tour?.property?.images?.[0]}
                  alt={tour?.property?.title}
                  className="w-full h-full object-cover"
                />
              </div>
              
              <div className="flex-1 min-w-0">
                <h3 className="font-medium text-foreground mb-1 truncate">
                  {tour?.property?.title}
                </h3>
                <p className="text-sm text-muted-foreground mb-2 truncate">
                  {tour?.property?.location}
                </p>
                
                <div className="flex items-center space-x-4 text-sm mb-3">
                  <div className="flex items-center space-x-1 text-primary">
                    <Icon name="Calendar" size={14} />
                    <span className="font-medium">{tour?.date}</span>
                  </div>
                  <div className="flex items-center space-x-1 text-primary">
                    <Icon name="Clock" size={14} />
                    <span className="font-medium">{tour?.time}</span>
                  </div>
                  <div className="flex items-center space-x-1 text-muted-foreground">
                    <Icon name="User" size={14} />
                    <span>{tour?.agent}</span>
                  </div>
                </div>

                <div className="flex items-center space-x-2">
                  <Button
                    variant="outline"
                    size="sm"
                    iconName="Edit"
                    iconPosition="left"
                    onClick={() => rescheduleTour(tour?.id)}
                  >
                    Reschedule
                  </Button>
                  <Button
                    variant="ghost"
                    size="sm"
                    iconName="X"
                    iconPosition="left"
                    onClick={() => cancelTour(tour?.id)}
                    className="text-error hover:text-error"
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="ghost"
                    size="sm"
                    iconName="MessageCircle"
                    iconPosition="left"
                    onClick={() => navigate(`/property-detail?id=${tour?.property?.id}`)}
                  >
                    Contact Agent
                  </Button>
                </div>
              </div>

              <div className="flex-shrink-0">
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                  tour?.status === 'confirmed' ?'bg-success/10 text-success' 
                    : tour?.status === 'pending' ?'bg-warning/10 text-warning' :'bg-muted text-muted-foreground'
                }`}>
                  {tour?.status?.charAt(0)?.toUpperCase() + tour?.status?.slice(1)}
                </span>
              </div>
            </div>

            {tour?.notes && (
              <div className="mt-3 pt-3 border-t border-border">
                <p className="text-sm text-muted-foreground">
                  <Icon name="FileText" size={14} className="inline mr-1" />
                  {tour?.notes}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScheduledTours;
